




































import { CameraImageActionsTypes } from "@/store/modules/CameraImage/types";
import DeviceVehicleCard from "@/components/Page/DeviceGraph/DeviceVehicleCard.vue";
import { store } from "@/store/store";
import Utils from "@/utils/utils";
import Vue from "vue";
import { CameraImage, GetDevice } from "@/store/modules/CameraImage/interface";
import Modal from "@/components/Modal/Modal.vue";

interface DeviceGraphCard {
  mounted: boolean;
  data: Array<any>;
  camera_images: Array<CameraImage>;
  should_show_graph_modal: boolean;
}

export default Vue.extend({
  name: "DeviceGraphCard",
  components: { DeviceVehicleCard, Modal },
  props: {
    device: {
      type: Object,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    max_labels: {
      type: Array,
      required: true
    }
  },
  async created() {
    await store.dispatch(CameraImageActionsTypes.GET_CAMERA_IMAGE, { id: this.device._id } as GetDevice);
    this.camera_images = [
      ...store.getters.CAMERA_IMAGE_ALL_ID.filter(
        (camera_image) => store.getters.CAMERA_IMAGE_BY_ID[camera_image].material === this.device._id
      ).map((camera_image) => store.getters.CAMERA_IMAGE_BY_ID[camera_image])
    ];
    this.data = this.format_data();
    this.mounted = true;
  },
  data(): DeviceGraphCard {
    return {
      camera_images: [],
      data: [] as Array<CameraImage>,
      mounted: false,
      should_show_graph_modal: false
    };
  },
  methods: {
    format_data(): Array<any> {
      let datas = [];
      for (const label of this.max_labels) {
        const r = this.camera_images.find((camera_image) => {
          return Utils.transformDateToYMDHMS(camera_image.d_h_process) === label;
        });
        r === undefined ? datas.push({ nb_jpg: NaN, nb_unknown: NaN, d_h_process: label }) : datas.push(r);
      }
      return datas;
    },
    get_datas_content() {
      const index = this.data.findIndex((data_) => Utils.transformDateToYMDHMS(data_.d_h_process) === this.labels[0]);
      return this.data.slice(index, this.data.length);
    },
    shouldDisplayModal() {
      this.should_show_graph_modal = true;
    },
    shouldHideModal() {
      this.should_show_graph_modal = false;
    }
  }
});
